export default __webpack_public_path__ + "static/media/money-shield.35a7faf6.svg";